import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';

const AppContext = createContext(null);
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const translations = {
  tr: {
    home: 'Ana Sayfa', rooms: 'Odalar', about: 'Hakkımızda', contact: 'İletişim',
    hero_title: 'Doğanın Kalbinde', hero_subtitle: 'Lüks Bir Kaçış',
    hero_description: "Amorium Hotel'de ahşap Fin evleri ve tarihi taş binalarda eşsiz bir konaklama deneyimi sizi bekliyor.",
    search_rooms: 'Oda Ara', check_in: 'Giriş Tarihi', check_out: 'Çıkış Tarihi',
    guests: 'Misafir', guest_count: 'misafir', nights: 'gece', night: 'gece',
    search: 'Ara', available_rooms: 'Müsait Odalar', per_night: '/ gece',
    view_details: 'Detayları Gör', book_now: 'Rezervasyon Yap',
    no_rooms: 'Seçilen tarihlerde müsait oda bulunmamaktadır.',
    capacity: 'Kapasite', size: 'Alan', amenities: 'Olanaklar',
    make_reservation: 'Rezervasyon Yap', first_name: 'Ad', last_name: 'Soyad',
    email: 'E-posta', phone: 'Telefon', nationality: 'Uyruk',
    special_requests: 'Özel İstekler', special_requests_placeholder: 'Varsa özel isteklerinizi belirtin...',
    continue_to_payment: 'Ödemeye Devam Et',
    payment_title: 'Güvenli Ödeme', payment_desc: 'TEB Sanal POS güvencesiyle güvenli ödeme',
    total_amount: 'Toplam Tutar', proceed_payment: 'Ödemeyi Tamamla',
    payment_processing: 'Ödeme sayfasına yönlendiriliyorsunuz...',
    test_mode: 'Test Modu', test_confirm: 'Test: Ödemeyi Onayla',
    booking_confirmed: 'Rezervasyon Onaylandı!', booking_ref: 'Rezervasyon Referansı',
    thank_you: 'Teşekkür Ederiz',
    confirmation_desc: 'Rezervasyon bilgileri e-posta adresinize gönderilecektir.',
    check_in_date: 'Giriş Tarihi', check_out_date: 'Çıkış Tarihi',
    total_nights: 'Toplam Gece', total_price: 'Toplam Fiyat', guest_name: 'Misafir',
    required_field: 'Bu alan zorunludur', invalid_email: 'Geçersiz e-posta',
    booking_error: 'Rezervasyon oluşturulurken hata oluştu', dates_required: 'Lütfen tarih seçin',
    dashboard: 'Dashboard', reservations: 'Rezervasyonlar', pricing: 'Fiyatlandırma',
    calendar: 'Takvim', reports: 'Raporlar', channels: 'Kanal Yönetimi',
    allotments: 'Kontenjan Takvimi',
    discounts: 'İndirimler',
    logout: 'Çıkış', login: 'Giriş', password: 'Şifre',
    status_confirmed: 'Onaylandı', status_pending_payment: 'Ödeme Bekliyor',
    status_cancelled: 'İptal', status_checked_in: 'Check-in', status_checked_out: 'Check-out',
    footer_rights: 'Tüm hakları saklıdır', currency: 'Para Birimi',
    person: 'kişi', select_dates_first: 'Önce tarih seçin',
    price_breakdown: 'Fiyat Detayı', subtotal: 'Ara Toplam',
    booking_summary: 'Rezervasyon Özeti', room: 'Oda', adult: 'Yetişkin',
    all_reservations: 'Tüm Rezervasyonlar', filter_by_status: 'Duruma Göre Filtrele',
    confirm: 'Onayla', cancel: 'İptal Et', edit: 'Düzenle', save: 'Kaydet', add: 'Ekle',
    delete: 'Sil', actions: 'İşlemler', name: 'Ad',
    base_price: 'Taban Fiyat', per_night_room: 'gece/oda', today_checkins: 'Bugün Giriş',
    today_checkouts: 'Bugün Çıkış', occupancy: 'Doluluk', monthly_revenue: 'Aylık Gelir',
    recent_reservations: 'Son Rezervasyonlar', room_management: 'Oda Yönetimi',
    pricing_rules: 'Fiyat Kuralları', add_rule: 'Kural Ekle', rule_type: 'Kural Tipi',
    seasonal: 'Sezonluk', weekend: 'Hafta Sonu', special_day: 'Özel Gün',
    multiplier: 'Çarpan', start_date: 'Başlangıç', end_date: 'Bitiş',
    block_dates: 'Tarihleri Bloke Et', unblock: 'Bloke Kaldır',
    channel_manager: 'Kanal Yöneticisi', coming_soon: 'Yakında',
    pending: 'Beklemede', revenue: 'Gelir', bookings: 'Rezervasyon', occupancy_rate: 'Doluluk Oranı',
    vat_settings: 'KDV Ayarları',
  },
  en: {
    home: 'Home', rooms: 'Rooms', about: 'About', contact: 'Contact',
    hero_title: 'In the Heart of Nature', hero_subtitle: 'A Luxurious Escape',
    hero_description: 'Experience an unparalleled stay in Finnish wooden houses and historic stone buildings at Amorium Hotel.',
    search_rooms: 'Search Rooms', check_in: 'Check-in', check_out: 'Check-out',
    guests: 'Guests', guest_count: 'guests', nights: 'nights', night: 'night',
    search: 'Search', available_rooms: 'Available Rooms', per_night: '/ night',
    view_details: 'View Details', book_now: 'Book Now',
    no_rooms: 'No rooms available for selected dates.',
    capacity: 'Capacity', size: 'Size', amenities: 'Amenities',
    make_reservation: 'Make Reservation', first_name: 'First Name', last_name: 'Last Name',
    email: 'Email', phone: 'Phone', nationality: 'Nationality',
    special_requests: 'Special Requests', special_requests_placeholder: 'Any special requests?',
    continue_to_payment: 'Continue to Payment',
    payment_title: 'Secure Payment', payment_desc: 'Secure payment powered by TEB Virtual POS',
    total_amount: 'Total Amount', proceed_payment: 'Complete Payment',
    payment_processing: 'Redirecting to payment page...',
    test_mode: 'Test Mode', test_confirm: 'Test: Confirm Payment',
    booking_confirmed: 'Booking Confirmed!', booking_ref: 'Booking Reference',
    thank_you: 'Thank You',
    confirmation_desc: 'Booking details will be sent to your email.',
    check_in_date: 'Check-in', check_out_date: 'Check-out',
    total_nights: 'Total Nights', total_price: 'Total Price', guest_name: 'Guest',
    required_field: 'This field is required', invalid_email: 'Invalid email',
    booking_error: 'Error creating reservation', dates_required: 'Please select dates',
    dashboard: 'Dashboard', reservations: 'Reservations', pricing: 'Pricing',
    calendar: 'Calendar', reports: 'Reports', channels: 'Channel Manager',
    allotments: 'Allotment Calendar',
    discounts: 'Discounts',
    logout: 'Logout', login: 'Login', password: 'Password',
    status_confirmed: 'Confirmed', status_pending_payment: 'Pending Payment',
    status_cancelled: 'Cancelled', status_checked_in: 'Checked In', status_checked_out: 'Checked Out',
    footer_rights: 'All rights reserved', currency: 'Currency',
    person: 'person', select_dates_first: 'Select dates first',
    price_breakdown: 'Price Breakdown', subtotal: 'Subtotal',
    booking_summary: 'Booking Summary', room: 'Room', adult: 'Adult',
    all_reservations: 'All Reservations', filter_by_status: 'Filter by Status',
    confirm: 'Confirm', cancel: 'Cancel', edit: 'Edit', save: 'Save', add: 'Add',
    delete: 'Delete', actions: 'Actions', name: 'Name',
    base_price: 'Base Price', per_night_room: '/night', today_checkins: "Today's Check-ins",
    today_checkouts: "Today's Check-outs", occupancy: 'Occupancy', monthly_revenue: 'Monthly Revenue',
    recent_reservations: 'Recent Reservations', room_management: 'Room Management',
    pricing_rules: 'Pricing Rules', add_rule: 'Add Rule', rule_type: 'Rule Type',
    seasonal: 'Seasonal', weekend: 'Weekend', special_day: 'Special Day',
    multiplier: 'Multiplier', start_date: 'Start Date', end_date: 'End Date',
    block_dates: 'Block Dates', unblock: 'Unblock',
    channel_manager: 'Channel Manager', coming_soon: 'Coming Soon',
    pending: 'Pending', revenue: 'Revenue', bookings: 'Bookings', occupancy_rate: 'Occupancy Rate',
    vat_settings: 'VAT Settings',
  }
};

const CURRENCY_SYMBOLS = { TRY: '₺', USD: '$', EUR: '€', GBP: '£' };
const EXCHANGE_RATES = { TRY: 1, USD: 0.028, EUR: 0.026, GBP: 0.022 };

export const AppProvider = ({ children }) => {
  const [language, setLanguage] = useState('tr');
  const [currency, setCurrency] = useState('TRY');
  const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken') || null);
  const [adminUser, setAdminUser] = useState(JSON.parse(localStorage.getItem('adminUser') || 'null'));

  // Auto-update currency when language changes
  const handleSetLanguage = (lang) => {
    setLanguage(lang);
    if (lang === 'tr') setCurrency('TRY');
    else if (lang === 'en') setCurrency('USD');
    else if (lang === 'de') setCurrency('EUR');
  };

  const t = (key) => translations[language]?.[key] || translations['en']?.[key] || key;

  const formatPrice = (amountTRY, targetCurrency = currency) => {
    if (amountTRY == null) return '-';
    const rate = EXCHANGE_RATES[targetCurrency] || 1;
    const amount = amountTRY * rate;
    const symbol = CURRENCY_SYMBOLS[targetCurrency] || '₺';
    if (targetCurrency === 'TRY') {
      return `${symbol}${amount.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    }
    return `${symbol}${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const adminLogin = async (email, password) => {
    const res = await axios.post(`${BACKEND_URL}/api/auth/login`, { email, password });
    const { access_token, admin } = res.data;
    localStorage.setItem('adminToken', access_token);
    localStorage.setItem('adminUser', JSON.stringify(admin));
    setAdminToken(access_token);
    setAdminUser(admin);
    return admin;
  };

  const adminLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setAdminToken(null);
    setAdminUser(null);
  };

  const apiHeaders = () => ({
    headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {}
  });

  /**
   * Normalize image URLs so they always point to the CURRENT backend domain.
   * Handles 3 cases:
   *  1. Relative path (/api/uploads/foo.jpg) → prepend BACKEND_URL
   *  2. Absolute URL pointing to a stale /api/uploads/... → rebase to BACKEND_URL
   *  3. External URL (unsplash, etc.) → leave untouched
   */
  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('/')) return `${BACKEND_URL}${url}`;
    try {
      const u = new URL(url);
      if (u.pathname.startsWith('/api/uploads/')) {
        return `${BACKEND_URL}${u.pathname}`;
      }
    } catch {
      // not a valid URL, return as-is
    }
    return url;
  };

  return (
    <AppContext.Provider value={{
      language, setLanguage: handleSetLanguage,
      currency, setCurrency,
      adminToken, adminUser,
      adminLogin, adminLogout,
      apiHeaders, t, formatPrice, getImageUrl,
      CURRENCY_SYMBOLS, EXCHANGE_RATES, BACKEND_URL,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
};

export default AppContext;
